const SHIP_LIST = [
    'exw_ex_works',
    'fca_free_carrier',
    'fas_free_alongside_ship',
    'fob_free_on_board',
    'cfr_cost_and_freight',
    'cif_cost_insurance_and_freight',
    'cpt_carriage_paid_to',
    'cip_carriage_insurance_paid_to',
    'dat_delivered_at_terminal',
    'dap_delivered_at_place',
    'ddp_delivered_duty_paid',
];
export const SHIPPING_OPTIONS = SHIP_LIST.map((type) => ({
    key: type,
    label: `resource.auction.properties.shipping.options.${type}.label`,
}));
